export default __webpack_public_path__ + "static/media/finance.a3d9ab89.svg";